module.exports = __webpack_public_path__ + "img/p6_bg.5ee66767.jpg";